module.exports = __webpack_public_path__ + "static/media/logo.e5596dae.svg";